// Margin-rate display: up to 9 decimals, trailing zeros trimmed; null/undefined → "—".
export function fmtRate(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return '—';
  let s = v.toFixed(9);
  if (s.includes('.')) s = s.replace(/0+$/, '').replace(/\.$/, '');
  return s;
}

function pad(n: number) {
  return String(n).padStart(2, '0');
}

export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function todayStart(): string {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00:00`;
}
export function todayEnd(): string {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T23:59:59`;
}

export const rowKeyOf = (r: { rowKey?: string; group: string; path: string }) =>
  r.rowKey && r.rowKey.length ? r.rowKey : `${r.group}|${r.path}`;

// Split the backend's comma-delimited ResolvedSymbol string into a clean list
// (mirrors GroupMarginRateCalculator.ExpandResolvedSymbols on the UI side: drop
// empties, the "*" wildcard, and any mask/negation tokens; de-dupe).
export function splitResolvedSymbols(resolvedSymbol: string | null | undefined): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of (resolvedSymbol ?? '').split(',')) {
    const s = raw.trim();
    if (!s || s === '*' || s.includes('*') || s.includes('!')) continue;
    const k = s.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(s);
  }
  return out;
}
